import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';

export const OverlaySidePanelBackgroundContext = createContext<Dispatch<SetStateAction<boolean>> | undefined>(
    undefined
);
